export const KEY_KEYPRESS = 'keypress';
